import { render, staticRenderFns } from "./CommonInfoTip.vue?vue&type=template&id=29c7f648"
import script from "./CommonInfoTip.vue?vue&type=script&lang=js"
export * from "./CommonInfoTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports